import styled, { css, keyframes } from "styled-components";

const shimmer = keyframes`
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
`;

const skeletonStyles = css`
    background: linear-gradient(90deg, var(--minor-bg-color) 25%, var(--secondary-bg-color) 50%, var(--minor-bg-color) 75%);
    background-size: 200% 100%;
    animation: ${shimmer} 1.5s infinite;
    border-radius: 4px;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

/**
 * Shimmering placeholder block, in the theme's colors, for content that is still loading.
 * Size it with styled(SkeletonBase), as the ecommerce list view skeleton does.
 */
export const SkeletonBase = styled.div`
    ${skeletonStyles}
`;

const InlineSkeleton = styled.span`
    ${skeletonStyles}
    display: inline-block;
    vertical-align: middle;
`;

type Props = {
    /** CSS width, e.g. "4.5rem" for a currency amount. */
    width?: string;
    /** CSS height; defaults to the current line's font size. */
    height?: string;
    className?: string;
    testId?: string;
};

/**
 * An inline placeholder bar standing in for a value that is loading or being recalculated, e.g. a checkout
 * total. Hidden from assistive technology: mark the surrounding region aria-busy instead.
 */
const OwSkeleton = ({ width = "100%", height = "1em", className, testId }: Props) => (
    <InlineSkeleton aria-hidden={true} className={className} data-testid={testId} style={{ width, height }} />
);

export default OwSkeleton;
